class HoculusHowToMeasure extends HTMLElement {
    referenceSelector = this.dataset.referenceSelector;
    tabReference = document.querySelector(this.referenceSelector)
    tabbedContent = document.querySelector('tabbed-content')

    constructor() { super() }

    connectedCallback() {
        if (!this.tabReference) return console.error('No corresponding tab found for the "How to Measure" button.')

        this.querySelector('button').addEventListener('click', () => {
            if (this.tabbedContent) this.tabbedContent.activateTab(this.tabReference)
            else if (!this.tabReference.querySelector('details').open) this.tabReference.open()

            this.tabReference.scrollIntoView({
                block: 'center',
                behavior: 'smooth',
            })
        })
    }
}

if (!customElements.get('hoculus-how-to-measure')) customElements.define('hoculus-how-to-measure', HoculusHowToMeasure)